import axiosConfig from "../utils/axiosConfig";

const addInvoice = (name, price, date, type, base64, mime, callback) => {
  axiosConfig("/invoice/add-invoice", {
    data: {
      name,
      price,
      date,
      type,
      base64,
      mime,
    },
  })
    .then((res) => {
      callback(res.data);
    })
    .catch(() => callback({ success: false }));
};

const updateInvoice = (id, name, price, date, type, callback) => {
  axiosConfig("/invoice/update-invoice", {
    data: {
      id,
      name,
      price,
      date,
      type,
    },
  })
    .then((res) => {
      callback(res.data);
    })
    .catch(() => callback({ success: false }));
};

const getInvoices = (callback) => {
  axiosConfig("/invoice/get-invoices")
    .then((res) => {
      callback(res.data);
    })
    .catch(() => callback({ success: false }));
};

const downloadInvoice = (id, callback) => {
  axiosConfig("/invoice/download-invoice", {
    data: {
      id,
    },
  })
    .then((res) => {
      callback(res.data);
    })
    .catch(() => callback({ success: false }));
};

const deleteInvoice = (id, callback) => {
  axiosConfig("/invoice/delete-invoice", {
    data: {
      id,
    },
  })
    .then((res) => {
      callback(res.data);
    })
    .catch(() => callback({ success: false }));
};

export { addInvoice, updateInvoice, getInvoices, downloadInvoice, deleteInvoice };
